module.exports = {"awsAccessKey":"","awsBucketName":"","host":""}


//////////////////
// WEBPACK FOOTER
// ./src/env.json
// module id = 99
// module chunks = 0